module.exports = "<div class=\"aside\">\n    <a class=\"close\" href=\"#\" title=\"Close\" ng-click=\"hideModal($event)\"></a>\n    <div id=\"injectedOneTouchInterstitial\">\n    </div>\n</div>\n<div class=\"pushLogo\"></div>\n<div class=\"logo\"></div>\n\n"


/*****************
 ** WEBPACK FOOTER
 ** ../~/noop-loader!./components/xo-login-components/src/fullpage-onetouch-upsell/template.html
 ** module id = 437
 ** module chunks = 1
 **/